const THUMB_SIZE = 256;
const AVATAR_BASE64_MAX = 80 * 1024;

const blobToDataUrl = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(new Error("Could not read image"));
    reader.readAsDataURL(blob);
});

const coverDraw = (ctx, bitmap, size) => {
    const scale = Math.max(size / bitmap.width, size / bitmap.height);
    const width = bitmap.width * scale;
    const height = bitmap.height * scale;
    ctx.drawImage(bitmap, (size - width) / 2, (size - height) / 2, width, height);
};

const createAvatarThumb = async (file) => {
    if (!file?.type?.startsWith("image/")) throw new Error("Choose an image");
    if (file.size > 8 * 1024 * 1024) throw new Error("Image is too large");
    const bitmap = await createImageBitmap(file);
    const canvas = document.createElement("canvas");
    canvas.width = THUMB_SIZE;
    canvas.height = THUMB_SIZE;
    coverDraw(canvas.getContext("2d"), bitmap, THUMB_SIZE);
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.82));
    if (!blob) throw new Error("Could not create thumbnail");
    return {
        blob,
        dataUrl: await blobToDataUrl(blob),
        bytes: blob.size,
        contentType: "image/jpeg",
    };
};

const shouldUploadAsBase64 = (bytes) => Number(bytes) <= AVATAR_BASE64_MAX;

export {
    THUMB_SIZE,
    AVATAR_BASE64_MAX,
    createAvatarThumb,
    shouldUploadAsBase64,
};
